import { type WorkerPayload } from "./workers/worker";

export class WorkerManager<Request extends object, Response> {
    private readonly worker: Worker;
    private seq = 0;
    private pendingDeferredMap = new Map<number, PromiseWithResolvers<Response>>();

    public constructor(worker: Worker) {
        this.worker = worker;
        this.worker.onmessage = this.onMessage;
    }

    private onMessage = (ev: MessageEvent<Response & WorkerPayload>): void => {
        const deferred = this.pendingDeferredMap.get(ev.data.seq);
        if (deferred) {
            this.pendingDeferredMap.delete(ev.data.seq);
            deferred.resolve(ev.data);
        }
    };

    public call(request: Request): Promise<Response> {
        const seq = this.seq++;
        const deferred = Promise.withResolvers<Response>();
        this.pendingDeferredMap.set(seq, deferred);
        this.worker.postMessage({ seq, ...request });
        return deferred.promise;
    }
}
